export default __webpack_public_path__ + "static/media/avatar.82d36c10.jpg";